<template lang="pug">
  v-row.desktop
    //- v-col(cols="12")
    //-   h1.mb-2 Оповещения
    //-   v-alert(
    //-     v-for="alert in alerts"
    //-     :key="alert.id"
    //-     @input="closeAlert(alert.id)"
    //-     color="info"
    //-     transition="slide-y-transition"
    //-     icon="mdi-information-variant"
    //-     dismissible dense text
    //-   )
    //-     p.mb-0 {{ alert.date }}
    //-     p.mb-0 {{ alert.message }}
    v-col(cols=12)
      component(:is="desktop")

</template>

<script>
import DesktopTeacher from '@/components/Desktops/DesktopTeacher.vue';
import DesktopStudent from '@/components/Desktops/DesktopStudent.vue';
import DesktopOrganization from '@/components/Desktops/DesktopOrganization.vue';

import { ROLES } from '@/modules/Auth/constants';

const DESKTOP_BY_ROLE = {
  [ROLES.organization.value]: DesktopOrganization,
  [ROLES.teacher.value]: DesktopTeacher,
  [ROLES.listener.value]: DesktopStudent,
  [ROLES.student.value]: DesktopStudent,
};

export default {
  computed: {
    desktop() {
      if (this.$user.studentMode) {
        return DesktopStudent;
      }
      return DESKTOP_BY_ROLE[this.$user.data.role];
    },
  },
  created() {
    if (this.$user.isOrganization) {
      this.$router.push({ name: 'MyCourseList' });
    }
  },
};
</script>
